// extracted by mini-css-extract-plugin
export default {"slotHighlighted":"cJ6ph6"};